import * as React from 'react';
import { SystemPopup } from '../../../library';
import { SystemGridAndForm } from '../SystemGridForm';
import SystemLanguageForm from './SystemLanguageForm';
import SystemLanguageGrid from './SystemLanguageGrid';

interface IAuditFormProps {
    visible: boolean, table: string, schema: string,
    secondaryTable: string, secondarySchema: string,
    onClose(): void, primaryKeyEncrypted: string, secondaryKeyEncrypted: string
}
interface IAuditFormState {
    refreshCounter: number
}

export default class SystemLanguage extends React.Component<IAuditFormProps, IAuditFormState> {
    constructor(props: any) {
        super(props);

    }

    state: any = {
        refreshCounter: 0,
    }

    onRefresh = () => {
        this.setState({ refreshCounter: this.state.refreshCounter + 1 })
    }


    render() {
        return (<>
            <SystemPopup visible={this.props.visible} onClose={this.props.onClose} popupTitle="" popupWidth="700px">
                <SystemLanguageForm />
                <SystemGridAndForm securityObject="Lookup.Lookup" label=" " onRefresh={this.onRefresh} form={SystemLanguageForm} grid={SystemLanguageGrid} showAdd={false}
                    data={"Test data"}
                />
            </SystemPopup>
        </>)

    }
}



